import React from 'react';
import PropTypes from 'prop-types';

const ColumnTitle = ({ columnTitle, columnIcon, children }) => (
  <div className="flex mt0 mb1 justify-between items-center pb1">
    <div className="flex">
      {columnIcon && (
        <div className="pr1 mr1 flex items-center">{columnIcon}</div>
      )}
      <h1 className="body-s text-black-tint-40 m0">{columnTitle}</h1>
    </div>
    {children}
  </div>
);

ColumnTitle.propTypes = {
  columnTitle: PropTypes.string,
  columnIcon: PropTypes.node,
  children: PropTypes.node,
};

ColumnTitle.defaultProps = {
  columnIcon: null,
  children: null,
  columnTitle: '',
};

export default ColumnTitle;
